export const songList = {
  ALL: [
    {
      image: "./images/p1.png",
      title: "BREAK MY HEART",
      artists: "DUA LIPA",
      link: "https://open.spotify.com/track/1raaNykBg1bDnWENUiglUA",
      rating: "4.5",
    },
    {
      image: "./images/p2.png",
      title: "HIGHER GROUND",
      artists: "MARTIN GARRIX & JOHN MARTIN",
      link: "https://open.spotify.com/track/0rohJsT6NWsThpukt0Xxdc",
      rating: "4.3",
    },
    {
      image: "./images/b1.png",
      title: "RAVE LOVE",
      artists: "W&W, AXMO & SONJA",
      link: "https://open.spotify.com/track/0YHL0wDP6b7ov6h0yEhorO",
      rating: "4.6",
    },
    {
      image: "./images/t1.png",
      title: "GREAT SPIRIT",
      artists: "ARMIN VAN BUUREN, VINI VICI & HIGHLIGHT TRIBE",
      link: "https://open.spotify.com/track/3Nku6gLNqnwUuq8GLkqyhW",
      rating: "4.5",
    },
    {
      image: "./images/t3.png",
      title: "CHAKRA",
      artists: "W&W  &  VINI VICI",
      link: "https://open.spotify.com/track/6UWZP82Q9I7lUtQaPBWJL7",
      rating: "4.7",
    },
    {
      image: "./images/p3.png",
      title: "THE BUSINESS",
      artists: "TIESTO",
      link: "https://open.spotify.com/track/6f3Slt0GbA2bPZlz0aIFXN",
      rating: "4.4",
    },
    {
      image: "./images/t2.png",
      title: "EXPLORATION OF SPACE",
      artists: "COSMIC GATE",
      link: "https://open.spotify.com/track/4WfRqfzYSSopd07hKWnxwr",
      rating: "4.3",
    },
    {
      image: "./images/b2.png",
      title: "DREAMS",
      artists: "DAVID GUETTA, MORTEN & LANIE GARDNER",
      link: "https://open.spotify.com/track/5ovAmYzYLeEmOX6P3bmlzV",
      rating: "4.4",
    },
    {
      image: "./images/b3.png",
      title: "THE PEOPLE",
      artists: "KSHMR & TIMMY TRUMPET",
      link: "https://open.spotify.com/track/3YRCgAw6nq0qcPpGOb3FZk",
      rating: "4.3",
    },
  ],
  TRANCE: [
    {
      image: "./images/t3.png",
      title: "CHAKRA",
      artists: "W&W  &  VINI VICI",
      link: "https://open.spotify.com/track/6UWZP82Q9I7lUtQaPBWJL7",
      rating: "4.7",
    },
    {
      image: "./images/t1.png",
      title: "GREAT SPIRIT",
      artists: "ARMIN VAN BUUREN, VINI VICI & HIGHLIGHT TRIBE",
      link: "https://open.spotify.com/track/3Nku6gLNqnwUuq8GLkqyhW",
      rating: "4.5",
    },
    {
      image: "./images/t2.png",
      title: "EXPLORATION OF SPACE",
      artists: "COSMIC GATE",
      link: "https://open.spotify.com/track/4WfRqfzYSSopd07hKWnxwr",
      rating: "4.3",
    },
  ],
  BIGROOM: [
    {
      image: "./images/b1.png",
      title: "RAVE LOVE",
      artists: "W&W, AXMO & SONJA",
      link: "https://open.spotify.com/track/0YHL0wDP6b7ov6h0yEhorO",
      rating: "4.6",
    },
    {
      image: "./images/b2.png",
      title: "DREAMS",
      artists: "DAVID GUETTA, MORTEN & LANIE GARDNER",
      link: "https://open.spotify.com/trackovAmYzYLeEmOX6P3bmlzV",
      rating: "4.4",
    },
    {
      image: "./images/b3.png",
      title: "THE PEOPLE",
      artists: "KSHMR & TIMMY TRUMPET",
      link: "https://open.spotify.com/track/3YRCgAw6nq0qcPpGOb3FZk",
      rating: "4.3",
    },
  ],
  POP: [
    {
      image: "./images/p1.png",
      title: "BREAK MY HEART",
      artists: "DUA LIPA",
      link: "https://open.spotify.com/track/1raaNykBg1bDnWENUiglUA",
      rating: "4.5",
    },
    {
      image: "./images/p3.png",
      title: "THE BUSINESS",
      artists: "TIESTO",
      link: "https://open.spotify.com/track/6f3Slt0GbA2bPZlz0aIFXN",
      rating: "4.4",
    },
    {
      image: "./images/p2.png",
      title: "HIGHER GROUND",
      artists: "MARTIN GARRIX & JOHN MARTIN",
      link: "https://open.spotify.com/track/0rohJsT6NWsThpukt0Xxdc",
      rating: "4.3",
    },
  ],
};
